<template>
	<div :style="shu.yangshi" class="zidingyi_wenzi">
		<el-carousel height="136px" :autoplay="true" :interval="2000">
			<el-carousel-item v-for="l in shu.shu">
				<el-image style="width: 100%;" :src="l.tu" fit="cover"></el-image>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>
 
<script>
	export default {
		name: 'Lunbo',
		props: {
			shu: {
				type: Object,
				default () {
					return {					
						yangshi: {}
					}
				}
			}
		},
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', [{
					tu: "https://limitao.myuan.cn/gongyong/shangchuan/tu/12/2019/11/r7Rc8mBC1BeuLcerUEUY7u22M7p12R.png"
				}])
			}
		}

	}
</script>
<link rel="stylesheet" href="Yangshi.css">
